import React from 'react';
import { Dialog, DialogContent, Box, Typography, Button } from '@mui/material';
import dayjs from 'dayjs';

const LatestCheckModal = ({ open, onClose, checkData }) => {
   if (!checkData) {
      return null;
   }

   return (
      <Dialog
         open={open}
         onClose={onClose}
         aria-labelledby="latest-check-modal-title"
         aria-describedby="latest-check-modal-description"
         maxWidth="xs" fullWidth
      >
                  <DialogContent>
         
         <Box sx={{ pt: 1 }}>
            <Typography id="latest-check-modal-title" variant="h6" component="h2">
               Details der letzten Prüfung
            </Typography>
            <Typography id="latest-check-modal-description" sx={{ mt: 2 }}>
               <strong>Kommentar:</strong> {checkData.comment}<br />
               <strong>Prüfdatum:</strong> {dayjs(checkData.date).format('DD.MM.YYYY')}<br />
               <strong>Nächstes Prüfdatum:</strong> {dayjs(checkData.next_date).format('DD.MM.YYYY')}<br />
               <strong>Standard:</strong> {checkData.standard}
            </Typography>
            <Button onClick={onClose} sx={{ mt: 3 }}>Schließen</Button>
         </Box>
                  </DialogContent>
         
      </Dialog>
   );
};

export default LatestCheckModal;